<template>
  <div class="md-layout">
    <!-- Formulario para agregar una actividad -->

    <div class="md-layout-item md-small-size-100" v-if="!phone && edit">
      <div class="md-card">
        <div class="md-card-content">
          <collapse
            id="collapsetotal23"
            :collapse="[$t('addButton')]"
            description="Una actividad puede ser clases o diferentes eventos que se desarrollan en el establecimiento donde tus clientes quieran participar. 'Crossift', 'Yoga', 'Fiesta de fin de año', etc."
            icon="keyboard_arrow_up"
            :open="open"
            class="bg-white"
          >
            <template slot="md-collapse-pane-1">
              <h5 v-if="newActivity._id">
                {{ $t("edit") }} {{ newActivity.name }}
              </h5>
              <div class="md-layout">
                <div class="md-layout-item float-left md-size-100">
                  <div class="md-field">
                    <label>{{ $t("activityLabel") }}</label>
                    <input
                      class="form-control"
                      v-model="newActivity.name"
                      :placeholder="$t('activityPlaceholder')"
                    />
                    <span v-if="errors.name" class="error">{{
                      $t("nameRequired")
                    }}</span>
                  </div>
                </div>
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-model="specificDate" />
                  <label class="form-check-label pt-2">{{ $t("defineSpecificDate") }}</label>
                </div>

                <div class="md-layout-item float-left md-size-100 text-left">
                  <div class="md-size-100" v-if="specificDate">
                    <input type="date" class="form-control" v-model="startDate" />
                    <label>Select date</label>
                  </div>
                  <div class="md-size-100" v-if="!specificDate">
                    <div class="md-field">
                      <label>{{ $t("dayOfWeekLabel") }}</label>
                      <select class="form-control" v-model="newActivity.day">
                        <option
                          v-for="(day, index) in daysOfWeek"
                          :key="index"
                          :value="index"
                          >Todos los {{ $t(day) }}</option
                        >
                      </select>
                      <span v-if="errors.day" class="error">{{
                        $t("dayRequired")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="md-layout-item float-left md-size-100 text-left">
                  <div class="md-size-100">
                    <div class="md-field">
                      <label>Rutina</label>
                      <select class="form-control" v-model="newActivity.planningId">
                        <option :value="false">- Vacio -</option>
                        <option
                          v-for="(item, index) in plannings"
                          :key="item._id"
                          :value="item._id"
                          >{{ item.name }}</option
                        >
                      </select>
                      <span v-if="errors.day" class="error">{{
                        $t("dayRequired")
                      }}</span>
                    </div>

                    <small
                      >Puedes ligar una rutina a esta actividad y de esa forma
                      tus clientes podrán seguir el plan de trabajo.</small
                    >
                  </div>
                </div>

                <div class="md-size-100">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" v-model="newActivity.registration" />
                    <label class="form-check-label pt-2">{{ $t("enableRegistrations") }}</label>
                  </div>
                </div>

                <div
                  class="md-size-100 card w-100 p-2"
                  v-if="newActivity.registration"
                >
                  <div class="md-size-100 mt-0 pt-0">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" v-model="newActivity.consumequota" />
                      <label class="form-check-label pt-2">
                        Solo clientes con clases disponibles pueden
                        inscribirse</label
                      >
                    </div>

                    <div class="w-100">
                      <small>
                        {{ $t("allowOverQuotaMessage") }}
                      </small>
                    </div>
                  </div>
                  <div class="md-size-100 mt-0 pt-0">
                    <div class="form-check">
                      <input 
                        type="checkbox" 
                        class="form-check-input" 
                        v-model="unlimitedQuota"
                        @change="unlimitedQuotaChange()"
                      />
                      <label class="form-check-label pt-2">{{ $t("unlimitedQuota") }}</label>
                    </div>
                  </div>

                  <strong v-if="!unlimitedQuota">{{ $t("quota") }}: </strong>
                  <small v-if="!unlimitedQuota"
                    >{{ $t("quotaMessage") }}
                    <span class="text-primary"
                      >https://{{ subdomain }}.app.gotake.it/#/schedule.</span
                    >
                  </small>
                  <div class="md-field" v-if="!unlimitedQuota">
                    <label>{{ $t("quota") }}</label>
                    <input type="number" class="form-control" v-model="newActivity.cupos" />
                  </div>
                </div>

                <div class="md-layout-item float-left md-size-100 pl-2">
                  <div class="md-field">
                    <label>{{ $t("startTimeLabel") }}</label>
                    <input type="time" class="form-control" v-model="newActivity.startTime" />
                    <span v-if="errors.startTime" class="error">{{
                      $t("startTimeRequired")
                    }}</span>
                  </div>

                  <div class="md-field">
                    <label>{{ $t("endTimeLabel") }}</label>
                    <input type="time" class="form-control" v-model="newActivity.endTime" />
                  </div>
                </div>

                <div class="md-layout-item float-left md-size-100">
                  <label class="md-form-label w-100">Establecimiento</label>
                  <small
                    >Si tienes mas de una sede o establecimiento, puedes
                    relacionar el evento.</small
                  >
                  <div class="md-field">
                    <select class="form-control" v-model="newActivity.stablishmentId">
                      <option :value="false">- Vacio -</option>

                      <option
                        v-for="stabl in allStablishments"
                        :key="stabl._id"
                        :value="stabl._id"
                      >
                        {{ stabl.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <button
                v-if="!newActivity._id"
                class="md-button md-raised md-primary"
                @click="saveAllActivity"
                :disabled="!validateFields()"
                >{{ $t("addButton") }}</button
              >
              <button
                v-else
                class="md-button md-raised md-primary"
                @click="saveAllActivity"
                :disabled="!validateFields()"
                >{{ $t("save") }}</button
              >
              <button
                v-if="newActivity._id"
                class="md-button md-raised md-danger"
                @click="cancel()"
                >{{ $t("cancel") }}</button
              >
            </template>
          </collapse>
        </div>
      </div>
    </div>

    <ScheduleCalendar
      :activities="activities"
      :phone="phone"
      :edit="edit"
      @refreshComponent="refreshComponent()"
      @editActivity="editActivity($event)"
      @deleteAct="deleteAct($event)"
    >
    </ScheduleCalendar>
  </div>
</template>

<script>
import permissionsMixin from "@/mixins/permissionsMixin";
import Swal from "sweetalert2";
import Collapse from "./Collapse.vue";
import ScheduleCalendar from "./ScheduleCalendar.vue";

// Mock functions to replace non-existent imports
const saveActivity = async (data) => {
  console.warn(
    "saveActivity is not available - Stablishments actions module was removed"
  );
  return { success: false, message: "Save activity not available" };
};

const getActivity = async (id) => {
  console.warn(
    "getActivity is not available - Stablishments actions module was removed"
  );
  return { success: false, data: null };
};

const deleteActivity = async (id) => {
  console.warn(
    "deleteActivity is not available - Stablishments actions module was removed"
  );
  return { success: false, message: "Delete activity not available" };
};

const getAllAction = async () => {
  console.warn(
    "getAllAction is not available - Stablishments actions module was removed"
  );
  return { success: false, data: [] };
};

const getAllPlanningsAction = async () => {
  console.warn(
    "getAllPlanningsAction is not available - Training actions module was removed"
  );
  return { success: false, data: [] };
};

export default {
  name: "ScheduleWeekGym",
  components: {
    Collapse,
    ScheduleCalendar,
  },
  mixins: [permissionsMixin],

  data() {
    return {
      startDate: false,
      unlimitedQuota: false,
      specificDate: false,
      activities: [],
      open: false,
      plannings: [],
      subdomain: window.location.hostname,
      allStablishments: [],
      newActivity: {
        consumequota: false,
        name: "",
        day: 1, // Cambiado a número (0 = Domingo, 1 = Lunes, etc.)
        startTime: "10:00",
        endTime: "11:00",
      },
      errors: {
        name: false,
        day: false,
        startTime: false,
      },
      daysOfWeek: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ],
    };
  },
  async created() {
    this.getAll();
    this.getAllPlannings();
  },
  props: {
    phone: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    completeview: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    qr: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    edit: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  computed: {
    activitiesByDay() {
      const sortedActivities = this.activities.reduce((acc, activity) => {
        if (!acc[activity.day]) {
          acc[activity.day] = [];
        }
        acc[activity.day].push(activity);
        return acc;
      }, {});

      // Ordenar las actividades por la hora de inicio
      Object.keys(sortedActivities).forEach((day) => {
        sortedActivities[day].sort((a, b) =>
          a.startTime.localeCompare(b.startTime)
        );
      });

      return sortedActivities;
    },
  },
  methods: {
    async getAllPlannings() {
      const response = await getAllPlanningsAction();
      if (response.ok) {
        this.plannings = response.plannings;
      } else {
        console.error("Failed to fetch plannings: ", response.message);
      }
    },
    formatDate(startDate) {
      // Creamos un nuevo Date con los mismos valores del parámetro
      const date = startDate;

      // Extraemos el año, mes y día directamente sin realizar conversiones de zonas horarias
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Meses son 0-11, sumamos 1
      const day = String(date.getDate()).padStart(2, "0");

      // Retornamos la fecha en formato YYYY-MM-DD
      return `${year}-${month}-${day}`;
    },
    cancel() {
      this.open = false;
      this.newActivity = {
        name: "",
        day: 1, // Cambiado a número (0 = Domingo, 1 = Lunes, etc.)
        startTime: "10:00",
        endTime: "11:00",
        consumequota: false,
      };
    },
    unlimitedQuotaChange() {
      if (!this.unlimitedQuota) {
        this.newActivity.cupos = 10;
      } else {
        this.newActivity.cupos = -1;
      }
    },
    refreshComponent() {
      this.$emit("refreshComponent");
    },
    validateFields() {
      this.errors.name = !this.newActivity.name;
      this.errors.startTime = !this.newActivity.startTime;

      return !this.errors.name && !this.errors.day && !this.errors.startTime;
    },
    async saveAllActivity() {
      if (!this.specificDate) {
        this.newActivity.startDate = null;
      } else {
        let startdate = this.formatDate(this.startDate);
        this.newActivity.startDate = startdate;
      }

      if (this.unlimitedQuota) {
        this.newActivity.cupos = -1;
      }

      await saveActivity(this.newActivity);
      Swal.fire({
        title: this.$tn("success"),
        icon: "success",
        confirmButtonText: "OK",
      });

      this.getAll();
    },
    async deleteAllActivity(id) {
      await deleteActivity(id);
      this.getAll();
    },
    deleteAct(id) {
      if (this.isDemo()) {
        return;
      }
      Swal.fire({
        title: this.$tn("areYouSure"),
        text: this.$tn("youWontBeAbleToRevertThis"),
        type: "warning",
        position: "top",
        confirmButtonText: this.$tn("delete"),
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteAllActivity(id);
        }
      });
    },
    async editActivity(act) {
      if (act.startDate) {
        this.startDate = new Date(act.startDate);
        this.specificDate = true;
      } else {
        this.specificDate = false;
      }

      if (act.cupos == -1) {
        this.unlimitedQuota = true;
      } else {
        this.unlimitedQuota = false;
      }

      this.open = true;
      this.newActivity = act;
    },
    async getAll() {
      try {
        const data = await getActivity();
        this.activities = data.activities;

        this.cancel();

        const stablishmentsResponse = await getAllAction();
        this.allStablishments = stablishmentsResponse.stablishments;
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
  },
};
</script>
